import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { EarningMechanismProductDiscountFragment } from '@occc/graphql';
import { awardHelper } from '@occc-app/offerHelpers/utils/awardHelper';
import { useCallback } from 'react';

const formatPurchaseThreshold = ({
  purchaseThresholdInt,
}: {
  purchaseThresholdInt: EarningMechanismProductDiscountFragment['purchaseThresholdInt'];
}): string => `${purchaseThresholdInt}`;

type ProductDiscountProps = {
  earningMechanism: EarningMechanismProductDiscountFragment;
};

export const ProductDiscount = ({ earningMechanism }: ProductDiscountProps) => {
  const navigate = useNavigate();
  const showPurchaseThreshold = !awardHelper.isCappedMoneyDiscountAward(
    earningMechanism.productDiscountAward,
  );
  const onChipClick = useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField
          disableTypography
          label='Included Product Groups'
          value={
            <ChipBox items={earningMechanism.eligibleProductGroups} onClick={onChipClick} mt={0} />
          }
        />
      </Grid>
      {showPurchaseThreshold && (
        <Grid item sm={3}>
          <InfoField label='Purchase Threshold' value={formatPurchaseThreshold(earningMechanism)} />
        </Grid>
      )}
    </Grid>
  );
};
